var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-layout',[_c('b-container',{staticClass:"onboarding-id-page page"},[_c('div',{staticClass:"page__header text-left"},[_c('h2',[_vm._v("Identification")])]),_c('onboarding-id-form')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }